/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Error_Dialog_No_ErrorInputs */



/**
* | output |
* | --- |
* | "The module no longer reports any error, you can close the window" |
*
* @param {Live_Error_Dialog_No_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const live_error_dialog_no_error = /** @type {((inputs?: Live_Error_Dialog_No_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Error_Dialog_No_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The module no longer reports any error, you can close the window")
	return /** @type {LocalizedString} */ ("Le module ne renvoie plus d'erreur, vous pouvez fermer la fenêtre")
});